import axiosRetry from 'axios-retry'
import store from '@/store'
import { createClient } from './createClient'

const instance = createClient({
    baseURL: process.env.VUE_APP_PICA_CORE_API_BASE_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },
    getAuthHeader: () => {
        const token = store.state.login.token
        return token ? `${token.type} ${token.token}` : null
    },
    refreshAuth: async () => {
        const state = store.state.login
        if (!state.authMethod || !state.refreshToken) {
            throw new Error('No refresh token available')
        }
        const AuthProviderFactory = require('@/domain/login/providers/AuthProviderFactory').default
        const provider = AuthProviderFactory.getProvider(state.authMethod)
        if (!provider.supportsRefresh()) {
            throw new Error('Provider does not support refresh')
        }
        await store.dispatch('login/refreshAuthToken')
    },
    retry: {
        retries: 4,
        retryDelay: (retryNumber) => Math.pow(2, retryNumber) * 1000,
        retryCondition: axiosRetry.isNetworkOrIdempotentRequestError
    }
})

export default instance


export function getFileAndDownload(options, filename=null, retryDelay=4000) {
    return instance({
        method: options.method === undefined ? 'get' : options.method,
        url: options.url,
        params: options.params || {},
        responseType: 'blob',
        'axios-retry': {
            retries: 3,
            retryDelay: (retryNumber) => Math.pow(2, retryNumber) * retryDelay,
            retryCondition: axiosRetry.isNetworkOrIdempotentRequestError
        }
    }).then(function(response) {
        let blob = new Blob([response.data], { type: options.fileType })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)

        if (filename === null) {
            const headerLine = response.headers['content-disposition']
            filename = headerLine.split('filename=')[1].replace(/"/g, '')
        }
        link.download = filename

        document.body.appendChild(link)
        link.click()
    })
}
